export function parseHeader(matrix) {
  const meta = {};
  for (let row of matrix) {
    if (row[0] && row[1]) {
      if (!row[2] && !row[3]) {
        meta[row[0]] = row[1];
      } else if (row[2] && row[3]) {
        meta[row[2]] = row[3];
      }
    }
  }
  return meta;
}
